import useCopyClipboard from 'hooks/useCopyClipboard'
import React, { useCallback } from 'react'
import { CheckCircle, Copy } from 'react-feather'
import styled from 'styled-components'
import { LinkStyledButton } from 'theme'

const CopyIcon = styled(LinkStyledButton)<{ noPadding?: boolean; gap?: string }>`
  color: ${({ color, theme }) => color || theme.accentAction};
  flex-shrink: 0;
  display: flex;
  ${({ gap }) =>
    gap &&
    `
    gap: ${gap} !important;
  `}
  text-decoration: none;
  ${({ noPadding }) =>
    noPadding &&
    `
    padding: 0 !important;
  `}
  :hover,
  :active,
  :focus {
    text-decoration: none;
    color: ${({ color, theme }) => color || theme.accentAction};
  }
`
const StyledText = styled.span<{ noPadding?: boolean; gap?: string; lineHeight?: string }>`
  font-size: 0.825rem;
  margin-left: ${({ noPadding }) => (noPadding ? '0' : '0.25rem')};
  ${({ theme }) => theme.flexRowNoWrap};
  align-items: center;
  line-height: ${({ lineHeight }) => lineHeight || '100%'};
  ${({ gap }) =>
    gap &&
    `
    display: flex;
    gap: ${gap} !important;
  `}
`

const Copied = ({ iconSize, noPadding, gap }: { iconSize?: number; noPadding?: boolean; gap?: string }) => (
  <StyledText noPadding={noPadding} gap={gap}>
    <CheckCircle size={iconSize ?? '16'} />
    <>Copied</>
  </StyledText>
)

const Icon = ({ iconSize, noPadding }: { iconSize?: number; noPadding?: boolean }) => (
  <StyledText noPadding={noPadding}>
    <Copy size={iconSize ?? '16'} />
  </StyledText>
)

interface BaseProps {
  toCopy: string
  color?: string
  iconSize?: number
  iconPosition?: 'left' | 'right'
  noPadding?: boolean
  gap?: string
}
export type CopyHelperProps = BaseProps & Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof BaseProps>

export default function CopyHelper({
  color,
  toCopy,
  children,
  iconSize,
  iconPosition,
  noPadding = false,
  gap,
}: CopyHelperProps) {
  const [isCopied, setCopied] = useCopyClipboard()
  const copy = useCallback(() => {
    setCopied(toCopy)
  }, [toCopy, setCopied])

  return (
    <CopyIcon onClick={copy} color={color} noPadding={noPadding} gap={gap}>
      {iconPosition === 'left' ? (
        isCopied ? (
          <Copied iconSize={iconSize} noPadding={noPadding} gap={gap} />
        ) : (
          <Icon iconSize={iconSize} noPadding={noPadding} />
        )
      ) : null}
      {iconPosition === 'left' && <>&nbsp;</>}
      {isCopied ? (
        ''
      ) : (
        <StyledText noPadding lineHeight="150%">
          {children}
        </StyledText>
      )}
      {iconPosition === 'right' && <>&nbsp;</>}
      {iconPosition === 'right' ? (
        isCopied ? (
          <Copied iconSize={iconSize} noPadding={noPadding} gap={gap} />
        ) : (
          <Icon iconSize={iconSize} noPadding={noPadding} />
        )
      ) : null}
    </CopyIcon>
  )
}
